declare global {
  interface Window {
    __openChangePwdDialog(): void;
  }
}

export interface ChangePwdFormState {
  oldPassword: string;
  password: string;
  confirmPasswprd: string;
}

export const genInitFormState = (): ChangePwdFormState => ({
  oldPassword: '',
  password: '',
  confirmPasswprd: '',
});
